import React, { useEffect, useState } from 'react';
import './styles';
import { useSelector } from 'react-redux';
import PLTable from '../../../../../components/PL/PLTable/PLTable';
import UISearchBar, { UI_SEARCH_BAR_TYPES } from '../../../../../components/UI/UISearchBar';
import { SERVICES_TABLE_TYPE } from '../../../../../components/PL/PLTable/config';
import { getFiltersProp } from '../../../../../redux/selectors/CurrentUserSelectors';
import { useLazyQuery } from '@apollo/react-hooks';
import { useLocation } from 'react-router-dom';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../components/PL/PLTable/TypeScriptHelpers';
import UILoadingPage from '../../../../../components/UI/UILoadingPage/UILoadingPage';
import * as strings from './strings';
import { GET_INDIVIDUAL_AGENT_SERVICES } from './queries';

export default function IndividualAgentServices({ agentId }: IndividualAgentServicesProps) {
	const QUERY_LIMIT = 25;

	const [services, setServices] = useState<ServiceType[]>();

	const filters = useSelector(getFiltersProp);
	const location = useLocation();

	let props = {
		filters,
		location
	};

	let baseVariables = { query: { clientId: { op_eq: agentId } } };
	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(QUERY_LIMIT, SERVICES_TABLE_TYPE, props, baseVariables);

	const [getServices, { data: servicesData }] = useLazyQuery(GET_INDIVIDUAL_AGENT_SERVICES, {
		variables
	});

	useEffect(() => {
		(async () => {
			await getServices();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (servicesData) {
				const fetchedServices: ServiceType[] = servicesData['services'];
				setServices(fetchedServices);
			}
		})();
	}, [servicesData]);

	const renderTabComponent = () => {
		return <UISearchBar style={{ margin: 12 }} type={UI_SEARCH_BAR_TYPES.service} onSearchUpdated={getServices} placeholder={strings.searchPlaceholder} />;
	};

	const renderTable = () => {
		if (!services) return <UILoadingPage />;
		return <PLTable type={SERVICES_TABLE_TYPE} limit={QUERY_LIMIT} emptySetText={strings.emptySetText} updateTable={getServices} data={services} />;
	};

	const renderContent = () => {
		return (
			<>
				{renderTabComponent()}
				{renderTable()}
			</>
		);
	};
	return renderContent();
}
